const SET_TEAM_TAGS = "SET_TEAM_TAGS";
const SET_ALL_USERS = "SET_ALL_USERS";
const SET_ACTIVE_USERS = "SET_ACTIVE_USERS";
const SET_INACTIVE_USERS = "SET_INACTIVE_USERS";
const SET_AT_RISK_USERS = "SET_AT_RISK_USERS";
const SET_NEW_USERS = "SET_NEW_USERS";
const SET_USER_VIEWS = "SET_USER_VIEWS";
const SET_COMPANIES = "SET_COMPANIES";
const SET_COMPANY_DETAILS = "SET_COMPANY_DETAILS";
const SET_COMPANY_MEMBERS = "SET_COMPANY_MEMBERS";
const SET_INSIGHTS_ACTIVE_MEMBERS = "SET_INSIGHTS_ACTIVE_MEMBERS";
const SET_INSIGHTS_AVERAGE_MEMBERS = "SET_INSIGHTS_AVERAGE_MEMBERS";
const SET_INSIGHTS_ACTIVE_CHANNELS = "SET_INSIGHTS_ACTIVE_CHANNELS";
const SET_INSIGHTS_MESSAGES_DATA = "SET_INSIGHTS_MESSAGES_DATA";
const SET_INSIGHTS_WEEKLY_MESSAGES = "SET_INSIGHTS_WEEKLY_MESSAGES";
const SET_INSIGHTS_ENGAGEMENT_METRICS = "SET_INSIGHTS_ENGAGEMENT_METRICS";
const SET_INSIGHTS_AVERAGE_REPLIES = "SET_INSIGHTS_AVERAGE_REPLIES";
const SET_INSIGHTS_ACTIVITY_COUNT = "SET_INSIGHTS_ACTIVITY_COUNT";
const SET_INSIGHTS_TTFR = "SET_INSIGHTS_TTFR";
const APPEND_COMPANY_MEMBER_TAG = "APPEND_COMPANY_MEMBER_TAG";
const REMOVE_COMPANY_MEMBER_TAG = "REMOVE_COMPANY_MEMBER_TAG";
const SET_GUILD_ROLES = "SET_GUILD_ROLES";
const SET_REPLY_MODAL_STATUS = "SET_REPLY_MODAL_STATUS";
const SET_MESSAGES_NO_REPLY = "SET_MESSAGES_NO_REPLY";

export {
  APPEND_COMPANY_MEMBER_TAG,
  REMOVE_COMPANY_MEMBER_TAG,
  SET_ACTIVE_USERS,
  SET_ALL_USERS,
  SET_AT_RISK_USERS,
  SET_COMPANIES,
  SET_COMPANY_DETAILS,
  SET_COMPANY_MEMBERS,
  SET_GUILD_ROLES,
  SET_INACTIVE_USERS,
  SET_INSIGHTS_ACTIVE_CHANNELS,
  SET_INSIGHTS_ACTIVE_MEMBERS,
  SET_INSIGHTS_ACTIVITY_COUNT,
  SET_INSIGHTS_AVERAGE_MEMBERS,
  SET_INSIGHTS_AVERAGE_REPLIES,
  SET_INSIGHTS_ENGAGEMENT_METRICS,
  SET_INSIGHTS_MESSAGES_DATA,
  SET_INSIGHTS_TTFR,
  SET_INSIGHTS_WEEKLY_MESSAGES,
  SET_MESSAGES_NO_REPLY,
  SET_NEW_USERS,
  SET_REPLY_MODAL_STATUS,
  SET_TEAM_TAGS,
  SET_USER_VIEWS,
};
